<template>
  <div v-if="content" v-editable="content" id="collectivites">
    <component :content="blok" :key="blok._uid" v-for="blok in content.body" :is="blok.component"></component>
  </div>
</template>

<script>
import api from "@/api";
import VueMarkdown from "vue-markdown";

export default {
  components: {
    VueMarkdown
  },
  data() {
    return {
      content: null
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const res = await api.get(
        `cdn/stories/${this.$i18n.locale}/pages/collectivites`
      );
      this.content = res.data.story.content;
    }
  }
};
</script>

<style lang="scss">
#collectivites {
  .btn-list {
    .list {
      //background-color: $primary-D;
      border-radius: 15px;
      width: 600px;
      max-width: $max-width;
      margin-bottom: 30px;
    }
  }
  .textBloc {
    margin-top: 1em;
  }
}
</style>
